import React, { useContext } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import DesktopSignUpPage from './DesktopSignUpPage';
import MobileSignUpPage from './MobileSignUpPage';

import { DeviceContext, deviceType, CredentialContext, credentialType } from '@providers';
import useIsComDomain from '@src/hooks/useIsComDomain';
import { baseUrl, emailVerifyRequestUrl } from '@src/app/routes';

interface RouteParams {
  code: string;
}

const SignupPage = () => {
  const { code } = useParams<RouteParams>();
  const { isMobile } = useContext<deviceType>(DeviceContext);
  const isComDomain = useIsComDomain();

  const { currentUser, anonymousCart, mgsAnonymousCart } = useContext<credentialType>(CredentialContext);

  if (currentUser?.token && !anonymousCart && !mgsAnonymousCart) {
    const afterSignupUrl = currentUser?.user?.emailVerified ? baseUrl : emailVerifyRequestUrl;

    return <Redirect to={afterSignupUrl} />;
  }

  return isMobile ? <MobileSignUpPage code={code} /> : <DesktopSignUpPage code={code} />;
};

export default SignupPage;
